// extracted by mini-css-extract-plugin
export default {"card":"overview_card__crx1Z","emailPerformanceChart":"overview_emailPerformanceChart__xk1rn"};